import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Defaults must match /app/backend/routes/site_content.py DEFAULTS
export const SITE_CONTENT_DEFAULTS = {
  hero_eyebrow: "Original Xbox Specialists",
  hero_line1: "Modded.",
  hero_line2: "Restored.",
  hero_line3: "Ready to play.",
  hero_description:
    "One-of-a-kind, customizable, high precision fit replacement shells to completely reinvigorate your Xbox's look. Also available are completed, modchipped, recapped and repasted Xboxes with 2TB HDDs, 80 wire IDE cables, Startech SATA to IDE adapters, in custom cases, from your imagination to reality. Parts and accessories, including OEM shell replacements, controllers, and cables available too.",
  cta_eyebrow: "Ready to Play?",
  cta_heading: "Get Your Original Xbox Today",
  cta_description:
    "Every console is hard-modded, recapped, repasted, cleaned and thoroughly tested. Every controller is refurbished to like-new functionality with new potentiometers (zero stick drift) and brand new thumbsticks.",
  cta_button_text: "View All Products",
  footer_tagline: "Your source for modded original Xbox consoles, refurbished controllers, and accessories.",
  footer_trademark: "Xbox is a registered trademark of the Microsoft Corporation.",
};

// Module-level cache so all consumers share one fetch until invalidated by admin.
let _cache = null;
let _promise = null;
const _listeners = new Set();

function notify() {
  _listeners.forEach((fn) => {
    try { fn(_cache || SITE_CONTENT_DEFAULTS); } catch { /* noop */ }
  });
}

async function fetchOnce() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = axios
    .get(`${API}/api/site-content`)
    .then(({ data }) => {
      _cache = { ...SITE_CONTENT_DEFAULTS, ...(data || {}) };
      notify();
      return _cache;
    })
    .catch(() => {
      _cache = { ...SITE_CONTENT_DEFAULTS };
      notify();
      return _cache;
    })
    .finally(() => {
      _promise = null;
    });
  return _promise;
}

export function invalidateSiteContent(next) {
  _cache = next ? { ...SITE_CONTENT_DEFAULTS, ...next } : null;
  notify();
}

export function useSiteContent() {
  const [content, setContent] = useState(_cache || SITE_CONTENT_DEFAULTS);

  useEffect(() => {
    const listener = (c) => setContent(c);
    _listeners.add(listener);
    if (!_cache) fetchOnce();
    return () => { _listeners.delete(listener); };
  }, []);

  return content;
}
